import { Component } from '@angular/core';

@Component({
    selector: 'lynkd-pattern-maps-dashboard',
    templateUrl: './maps-dashboard.component.html',
    styleUrls: ['./maps-dashboard.component.scss']
})
export class MapsDashboardComponent {}
